import axios from 'axios'
import {getValue} from './auth'
window.promisify = function(fn, receiver) {
    return (...args) => {
      return new Promise(function(resolve, reject) {
        fn.apply(receiver, [
          ...args,
          res => {
            return resolve(res);
          },
          error => {
            return reject(error);
          }
        ]);
      });
    };
  };

  export async function getCertId(that){
    let promiseFunc = window.promisify(window.initXA, window);

    let result = await promiseFunc().catch(msg => "error");
    if ("error" === result) {
      that.$message.error("签名控件初始化失败");
      return null;
    }

    promiseFunc = window.promisify(window.SOF_GetUserList, window);
    result = await promiseFunc().catch(msg => "error");
    if ("error" === result) {
      that.$message.error("获取证书失败");
      return null;
    }
    result = result.retVal.split("&&&").filter(item => !!item);

    if (!result || result.length == 0) {
      that.$message.error("请插入带有合法证书的UKEY");
      return null;
    }
    // if (result.length > 1) {
    //   that.$message.error("检测到多个UKEY，请移除未使用的UKEY");
    //   return false;
    // }
    //判断用户信息
    result = result[0].split("||")
    const userCode = result[0]
    if(userCode != getValue('userName')){
      that.$message.error("请插入当前登陆用户绑定的ukey");
      return null;
    }
    result = result[1];
    return result
  }

  export async function signHashData(certId,hashData){
   // console.log(certId,hashData,'0x00000004')
    let promiseFunc = window.promisify(window.SOF_SignHashData, window);
    let result = await promiseFunc(certId,hashData,0x00000004).catch(msg => console.log(msg));
    return result
  }

  export async function getUserCert(certId,that){
    //const certId = await getCertId(that)
    if(!certId){
      return null
    }
    let promiseFunc = window.promisify(window.SOF_ExportUserCert, window);

    let result = await promiseFunc(certId).catch(msg => "error");
    if ("error" === result) {
      that.$message.error("获取用户证书失败");
      return null;
    }
    return result.retVal;
  }
export async function isLogin(certId) {
  let result = certId;//await getCertId(that)
  if (!result) {
    return false
  }
  let promiseFunc = window.promisify(window.SOF_SignHashData, window);
  result = await promiseFunc(certId, "j0iWgheBt1MUK3ADkN0TamOqk/vZ0YePA+p80jhMKOQ=", 0x00000004).catch(msg => ({retVal:''}));
  console.log(result,11)
  return !!result.retVal
}
export async function loginAuth(certId,that) {
    let result = certId;//await getCertId(that)
    if(!result){
      return false
    }
    const { value } = await that.$prompt("请输入密码", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "password"
    }).catch(msg => ({ value: null }));
    //登陆认证

    if (!value) {
      return false;
    }
    let promiseFunc = window.promisify(window.SOF_Login, window);

    result = await promiseFunc(result, value).catch(msg => "error");

    if ("error" === result) {
      that.$message.error("证书认证失败，请确保证书合法！");
      return false;
    }
    result = result.retVal;
    if (result === true) {
      return true;
    } else {
      that.$message.error("证书认证失败，密码错误！");
      return false;
    }
  }

  function verify(processMsg){
    axios.get(`/api/caservice/showPdf/caPdfVerify/${processMsg.bizPk}?taskId=${processMsg.taskId}`)
    .then(result=>{
      if(result.success){
        that.$message.success('验章通过')
      }else{
        that.$message.error(result.message)
      }
    }).catch(msg=>{
      that.$message.error(msg)
    })
  }



// WEBPACK FOOTER //
// ./src/api/bjca/bjcalib.js